import React from "react";
import Typography from "antd/lib/typography";
import { useIntl } from "react-intl";
import Input from "antd/lib/input";
import { store } from "@codex/store/index";
import { verifyCodeRequest, resendCodeRequest } from "../LoginForm/ducks/actions";
import { openDialog } from "@codex/app-ducks/actions";
import LoginForm from "../LoginForm";
import Form from "antd/lib/form/Form";
var PinCodeForm = function (props) {
    var classes = props.classes, form = props.form, didCodeVerificationFailed = props.didCodeVerificationFailed;
    var formatMessage = useIntl().formatMessage;
    var getFieldDecorator = form.getFieldDecorator;
    var formWrapper = null;
    var getPinCode = function () {
        var inputs = Array.from(formWrapper.getElementsByTagName('input')).reverse();
        var pin = inputs.reduce(function (p, input) { return p + input.value; }, '');
        return [pin, inputs];
    };
    var submitForm = function () {
        var code = getPinCode()[0];
        setTimeout(function () {
            props.form.validateFields(function (err, values) {
                if (!err) {
                    store.dispatch(verifyCodeRequest({
                        code: code,
                        phone: store.getState().auth.login.phone
                    }));
                }
            });
        });
    };
    var inputOnChange = function (e) {
        if (formWrapper) {
            var _a = getPinCode(), pin = _a[0], inputs = _a[1];
            var value = e.target.value;
            if (value.length > 1) {
                e.target.value = value[0];
            }
            var nextInput = inputs[pin.length];
            if (nextInput && value !== '') {
                nextInput.focus();
            }
            if (pin.length === 4) {
                submitForm();
            }
        }
    };
    var inputOnKeyDown = function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            submitForm();
        }
    };
    return (React.createElement("div", { ref: function (el) { return formWrapper = el; }, className: classes.root },
        React.createElement(Typography, { component: "p", className: classes.title }, formatMessage({ id: "pincode.form.title" })),
        React.createElement(Typography, { component: "p", className: classes.subTitle }, formatMessage({ id: "pincode.form.subTitle" })),
        React.createElement("div", { className: classes.codeContainer },
            React.createElement(Form, { layout: "inline", className: classes.form },
                React.createElement(Form.Item, { hasFeedback: true }, getFieldDecorator("number1", {
                    rules: [
                        { required: true, message: formatMessage({ id: "pinCodeForm.number.required.massage" }) },
                        { pattern: /\b[0-9]\b/, message: formatMessage({ id: "pinCodeForm.number.error.massage" }) },
                    ]
                })(React.createElement(Input, { className: classes.input, type: "number", onChange: inputOnChange, onKeyDown: inputOnKeyDown, maxLength: 1, pattern: '/\b[0-9]\b/' }))),
                React.createElement(Form.Item, { hasFeedback: true }, getFieldDecorator("number2", {
                    rules: [
                        { required: true, message: formatMessage({ id: "pinCodeForm.number.required.massage" }) },
                        { pattern: /\b[0-9]\b/, message: formatMessage({ id: "pinCodeForm.number.error.massage" }) },
                    ]
                })(React.createElement(Input, { className: classes.input, type: "number", onKeyDown: inputOnKeyDown, onChange: inputOnChange, maxLength: 1, pattern: '\b[0-9]\b' }))),
                React.createElement(Form.Item, { hasFeedback: true }, getFieldDecorator("number3", {
                    rules: [
                        { required: true, message: formatMessage({ id: "pinCodeForm.number.required.massage" }) },
                        { pattern: /\b[0-9]\b/, message: formatMessage({ id: "pinCodeForm.number.error.massage" }) },
                    ]
                })(React.createElement(Input, { className: classes.input, onKeyDown: inputOnKeyDown, type: "number", onChange: inputOnChange, maxLength: 1, pattern: '\b[0-9]\b' }))),
                React.createElement(Form.Item, { hasFeedback: true }, getFieldDecorator("number4", {
                    rules: [
                        { required: true, message: formatMessage({ id: "pinCodeForm.number.required.massage" }) },
                        { pattern: /\b[0-9]\b/, message: formatMessage({ id: "pinCodeForm.number.error.massage" }) },
                    ]
                })(React.createElement(Input, { className: classes.input, type: "number", onChange: inputOnChange, autoFocus: true, onKeyDown: inputOnKeyDown, maxLength: 1, pattern: '\b[0-9]\b' }))))),
        didCodeVerificationFailed &&
            React.createElement("div", { className: classes.codeError }, formatMessage({ id: "pincode.form.invalidCodeError" })),
        React.createElement("div", { className: classes.centerText },
            React.createElement("span", { style: { color: "#5a5a6c", textDecoration: 'none' }, key: "1", onClick: function (e) { return e.preventDefault(); }, className: classes.text }, formatMessage({ id: "pincode.form.verify" }))),
        React.createElement("div", { className: classes.centerText },
            React.createElement("a", { key: "2", onClick: function () {
                    store.dispatch(resendCodeRequest({
                        query: store.getState().auth.login.phone
                    }));
                }, className: classes.text }, formatMessage({ id: "pincode.form.resend" }))),
        React.createElement("div", { className: classes.centerText, onClick: function () { return store.dispatch(openDialog({ Component: LoginForm })); } },
            React.createElement("span", { key: "3", className: classes.text }, formatMessage({ id: "pincode.form.resend.another.number" })))));
};
export default PinCodeForm;



//////////////////
// WEBPACK FOOTER
// ./src/components/PinCodeForm/PinCodeForm.tsx
// module id = 717
// module chunks = 0